import { ChangeEvent, FormEvent, useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { LoginFormProp } from "../../../../../Types/Others.type";
import CommonLogo from "./CommonLogo";
import { Btn, H2, P } from "../../../../../AbstractElements";
import {
  Agreewith,
  CreateAccount,
  EmailAddress,
  Href,
  PrivacyPolicy,
  YourName,
} from "../../../../../Utils/Constants";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { backendbaseUrl } from "../../../../../Utils/baseUrl";
import { toast } from "react-toastify";
export default function RegisterForm({ logoClass }: LoginFormProp) {
  // const [isPasswordVisible, setPasswordVisible] = useState(false);
  // const toggle = () => setPasswordVisible(!isPasswordVisible);
  const [formData, setFormData] = useState({
    first_name: "",
    lastName: "",
    email: "",
    password: "",
    checkbox1: false,
    company_name: "",
    mobile_number: "",
  });
  const [successModal, SetSuccessModal] = useState(false);
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [id]: type === "checkbox" ? checked : value,
    });
  };
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${backendbaseUrl}/company/company-trail/`,
        formData
      );
      if (response.status === 201) {
        SetSuccessModal(true);
        console.log("yes rerendered");
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error("Please fill every field");
        } else {
          toast.error(
            error.response.data.message || "An unknown error occurred"
          );
        }
      } else {
        toast.error("Network error or server is down");
      }
    }

    // setFormData({ name: '', lastName: '', email: '', password: '', checkbox1: false, companyName:'',mobileNumber:''});
  };
  return successModal ? (
    <ThankYouDiv />
  ) : (
    <div>
      <div>
        <CommonLogo logoClass={logoClass} />
      </div>
      <div className="login-main">
        <Form className="theme-form" onSubmit={handleSubmit}>
          <H2>Start your 14 days Instant Trial</H2>
          <P>100% free. No credit card needed</P>
          <FormGroup>
            <Col>
              <Label className="pt-0">{YourName}</Label>
            </Col>
            <Row className="g-2">
              <Col xs={6}>
                <Input
                  type="text"
                  id="first_name"
                  required
                  placeholder="First name"
                  value={formData.first_name}
                  onChange={handleInputChange}
                />
              </Col>
              <Col xs={6}>
                <Input
                  type="text"
                  id="lastName"
                  required
                  placeholder="Last name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Col>
              <Label>{EmailAddress}</Label>
            </Col>
            <Input
              type="email"
              id="email"
              required
              placeholder="Test@gmail.com"
              value={formData.email}
              onChange={handleInputChange}
            />
          </FormGroup>
          <FormGroup>
            <Col>
              <Label>Company Name</Label>
            </Col>
            <Input
              type="text"
              id="company_name"
              required
              placeholder="Company name"
              value={formData.company_name}
              onChange={handleInputChange}
            />
          </FormGroup>

          <FormGroup>
            <Col>
              <Label>Mobile Number</Label>
            </Col>
            <Input
              type="number"
              id="mobile_number"
              required
              placeholder="Company name"
              value={formData.mobile_number}
              onChange={handleInputChange}
            />
          </FormGroup>

          {/* <FormGroup>
                        <Col><Label>{Password}</Label></Col>
                        <div className="form-input position-relative">
                            <Input type={isPasswordVisible ? 'text' : 'password'} id="password" name="login[password]" required placeholder="*********" value={formData.password} onChange={handleInputChange} />
                            <div className='show-hide' onClick={toggle}>
                                <span className={!isPasswordVisible ? 'show' : ''}></span>
                            </div>
                        </div>
                    </FormGroup> */}
          <FormGroup className="mb-0">
            <div className="checkbox p-0">
              <Input
                id="checkbox1"
                type="checkbox"
                checked={formData.checkbox1}
                onChange={handleInputChange}
              />
              <Label className="text-muted" htmlFor="checkbox1">
                {Agreewith}
              </Label>
              <a className="ms-2" href={Href}>
                {PrivacyPolicy}
              </a>
            </div>
            <Btn color="primary" className="w-100" block>
              {CreateAccount}
            </Btn>
          </FormGroup>
          {/* <SocialLinks logtext={"Already have an account?"} btntext={SignIn} /> */}
        </Form>
      </div>
    </div>
  );
}


const ThankYouDiv = () => {
  const navigate = useNavigate();

  const loginPageUrl = () => {
    navigate('/');

  }

  return (
    <div className="col-md-12 col-lg-8">
      <div className="pricingtable">
        <div className="pricingtable-header">
          <h3 className="title">thankyou </h3>
        </div>

        <ul className="pricing-content simple-list list-group">
          <li className="list-group-item">Once we Have verified! we will get back to you !</li>
        </ul>
        <div className="pricingtable-signup">
          <a href="/auth/sign_up">
            <button className="btn btn-primary btn-lg" onClick={loginPageUrl}>Go back</button>
          </a>
        </div>
      </div>
    </div>);
};